import React from 'react'
import { useTranslation } from 'react-i18next'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

const UserInfoTable = props => {
	const { t } = useTranslation();
	const { data } = props
	return (
		<Table>
            <TableHead>
                <TableRow>
					<TableCell style={{paddingLeft: '30px'}}>{t('name')}</TableCell>
                    <TableCell>{t('phone')}</TableCell>
                    <TableCell>{t('email')}</TableCell>
                    <TableCell>{t('address')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell style={{paddingLeft: '30px'}}>{data.get('memberName')}</TableCell>
                    <TableCell>{data.get('memberPhone')}</TableCell>
                    <TableCell>{data.get('memberEmail')}</TableCell>
                    <TableCell>{data.get('memberAddress')}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
	)
}

export default UserInfoTable